<template>
  <div>
    <div class="search">
      <el-input placeholder="请输入设备IMEI查询" style="width: 200px" v-model="searchParams.deviceImei"></el-input>
      <el-date-picker
        v-model="searchParams.reportDateRange"
        type="datetimerange"
        range-separator="至"
        start-placeholder="上报开始日期"
        end-placeholder="上报结束日期"
        style="margin-left: 10px; width: 380px"
        value-format="yyyy-MM-dd HH:mm:ss">
      </el-date-picker>
      <el-button type="info" plain style="margin-left: 10px" @click="load(1)">查询</el-button>
      <el-button type="warning" plain style="margin-left: 10px" @click="reset">重置</el-button>
    </div>

    <div class="operation">
      <el-button type="danger" plain @click="delBatch">批量删除</el-button>
      <el-input
        placeholder="按ID范围删除，如: 1-1000"
        style="width: 200px; margin-left: 10px"
        v-model="deleteRange"
        clearable>
      </el-input>
      <el-button type="danger" plain style="margin-left: 10px" @click="delByRange">删除范围</el-button>
      <el-button type="success" plain style="margin-left: 10px" @click="exportToCsv">导出CSV</el-button>
    </div>

    <div class="table">
      <el-table :data="tableData" strip @selection-change="handleSelectionChange" @sort-change="handleSortChange">
        <el-table-column type="selection" width="55" align="center" fixed="left"></el-table-column>
        <el-table-column prop="id" label="序号" width="80" align="center" sortable fixed="left"></el-table-column>
        <el-table-column prop="deviceImei" label="设备IMEI" width="160" fixed="left"></el-table-column>
        <el-table-column prop="soc" label="SOC (%)" width="100" sortable="custom">
          <template v-slot="scope">
            <el-progress
              :percentage="scope.row.soc || 0"
              :color="getSocColor(scope.row.soc || 0)"
              :show-text="scope.row.soc !== null"
              :stroke-width="8">
            </el-progress>
            <span v-if="scope.row.soc === null" style="color: #999; font-size: 12px;">暂无数据</span>
          </template>
        </el-table-column>
        <el-table-column prop="temperature" label="温度 (°C)" width="100" sortable="custom"></el-table-column>
        <el-table-column prop="voltage" label="电压 (mV)" width="100" sortable="custom"></el-table-column>
        <el-table-column prop="current" label="电流 (mA)" width="100" sortable="custom"></el-table-column>
        <el-table-column prop="actualCapacityMah" label="剩余容量 (mAh)" width="150"></el-table-column>
        <el-table-column prop="fccMah" label="FCC满充容量 (mAh)" width="160">
          <template v-slot="scope">
            <span v-if="scope.row.fccMah">{{ scope.row.fccMah }}</span>
            <span v-else style="color: #999; font-size: 12px;">暂无数据</span>
          </template>
        </el-table-column>
        <el-table-column prop="cycleCountSnapshot" label="循环次数快照" width="140"></el-table-column>
        <el-table-column prop="latitude" label="纬度" width="120"></el-table-column>
        <el-table-column prop="longitude" label="经度" width="120"></el-table-column>
        <el-table-column prop="reportedAt" label="上报时间" width="170" sortable="custom">
          <template v-slot="scope">
            {{ formatDateTime(scope.row.reportedAt) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100" fixed="right">
          <template v-slot="scope">
            <el-button size="mini" type="danger" plain @click="del(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
            background
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page="pageNum"
            :page-sizes="[20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 设备监控日志通常不在此处新增或编辑，因此没有弹窗表单 -->

  </div>
</template>

<script>
export default {
  name: "DeviceMonitorLog",
  data() {
    return {
      tableData: [],
      pageNum: 1,
      pageSize: 20,
      total: 0,
      searchParams: {
        deviceImei: null,
        reportDateRange: [],
        sortField: null,
        sortOrder: null,
      },
      user: JSON.parse(localStorage.getItem('xm-user') || '{}'), // 可能用于权限控制，暂时保留
      ids: [],
      deleteRange: '' // ID范围删除输入框
    }
  },
  created() {
    this.applyDefaultDateRange();
    this.load(1);
  },
  methods: {
    formatDateValue(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    getDefaultDateRange() {
      const end = new Date();
      const start = new Date(end.getTime() - 30 * 24 * 60 * 60 * 1000);
      return [this.formatDateValue(start), this.formatDateValue(end)];
    },
    applyDefaultDateRange() {
      if (!this.searchParams.reportDateRange || this.searchParams.reportDateRange.length !== 2) {
        this.searchParams.reportDateRange = this.getDefaultDateRange();
      }
    },
    handleSortChange({ column, prop, order }) {
      this.searchParams.sortField = prop;
      this.searchParams.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : null);
      this.load(1);
    },
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) return '';
      const date = new Date(dateTimeStr);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    del(id) {
      this.$confirm('您确定删除这条日志吗？删除后无法恢复。', '确认删除', { type: "warning" }).then(() => {
        this.$request.delete('/deviceMonitorLogs/delete/' + id).then(res => {
          if (res.code === '200') {
            this.$message.success('操作成功');
            this.load(this.pageNum); // 删除后停留在当前页
          } else {
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {});
    },
    handleSelectionChange(rows) {
      this.ids = rows.map(v => v.id);
    },
    delBatch() {
      if (!this.ids.length) {
        this.$message.warning('请选择要删除的日志');
        return;
      }
      this.$confirm(`您确定批量删除选中的 ${this.ids.length} 条日志吗？删除后无法恢复。`, '确认删除', { type: "warning" }).then(() => {
        this.$request.delete('/deviceMonitorLogs/delete/batch', { data: this.ids }).then(res => {
          if (res.code === '200') {
            this.$message.success('操作成功');
            this.load(1); // 批量删除后回到第一页
          } else {
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {});
    },
    async delByRange() {
      if (!this.deleteRange || !this.deleteRange.trim()) {
        this.$message.warning('请输入要删除的ID范围');
        return;
      }

      // 解析范围输入，支持格式：1-1000 或 1 - 1000
      const rangePattern = /^(\d+)\s*-\s*(\d+)$/;
      const match = this.deleteRange.trim().match(rangePattern);

      if (!match) {
        this.$message.error('请输入正确的范围格式，如: 1-1000');
        return;
      }

      const startId = parseInt(match[1]);
      const endId = parseInt(match[2]);

      if (startId > endId) {
        this.$message.error('起始ID不能大于结束ID');
        return;
      }

      const totalCount = endId - startId + 1;

      try {
        await this.$confirm(
          `您确定要删除ID从 ${startId} 到 ${endId} 的所有日志吗？<br>此操作将删除最多 ${totalCount} 条记录，且无法恢复！`,
          '危险操作确认',
          {
            type: 'error',
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定删除',
            cancelButtonText: '取消'
          }
        );
      } catch {
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: '正在删除数据，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      try {
        // 使用后端的范围删除接口，一次性删除
        const res = await this.$request.delete('/deviceMonitorLogs/delete/range', {
          params: {
            startId: startId,
            endId: endId
          }
        });

        loading.close();

        if (res.code === '200') {
          const deletedCount = res.data || totalCount;
          this.$message.success(`删除成功！已删除 ${deletedCount} 条数据`);
          this.deleteRange = ''; // 清空输入框
          this.load(1); // 刷新列表回到第一页
        } else {
          this.$message.error('删除失败: ' + res.msg);
        }
      } catch (error) {
        loading.close();
        console.error('删除失败:', error);
        this.$message.error('删除失败: ' + (error.message || '未知错误'));
      }
    },
    load(pageNum) {
      if (pageNum) this.pageNum = pageNum;
      
      let startTime = null;
      let endTime = null;
      if (this.searchParams.reportDateRange && this.searchParams.reportDateRange.length === 2) {
        startTime = this.searchParams.reportDateRange[0];
        endTime = this.searchParams.reportDateRange[1];
      }

      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        deviceImei: this.searchParams.deviceImei,
        startTime: startTime,
        endTime: endTime,
      };

      for (const key in params) {
        if (params[key] === null || params[key] === undefined || params[key] === '') {
          delete params[key];
        }
      }

      this.$request.get('/deviceMonitorLogs/selectPage', {
        params
      }).then(res => {
        if (res.code === '200') {
          this.tableData = res.data?.list;
          this.total = res.data?.total;
        } else {
          this.$message.error(res.msg);
        }
      }).catch(err => {
        console.error("Request failed:", err);
        this.$message.error('请求失败: ' + (err.response?.data?.msg || err.message || '未知错误'));
      })
    },
    reset() {
      this.searchParams = {
        deviceImei: null,
        reportDateRange: this.getDefaultDateRange(),
        sortField: null,
        sortOrder: null,
      };
      this.load(1);
    },
    handleCurrentChange(pageNum) {
      this.load(pageNum);
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.load(1);
    },
    getSocColor(soc) {
      if (soc <= 20) return '#F56C6C'; // 红色 - 低电量
      if (soc <= 50) return '#E6A23C'; // 橙色 - 中等电量
      return '#67C23A'; // 绿色 - 高电量
    },
    async exportToCsv() {
      const hasDateFilter = this.searchParams.reportDateRange && this.searchParams.reportDateRange.length === 2;
      const hasImeiFilter = !!this.searchParams.deviceImei;
      if (!hasDateFilter && !hasImeiFilter) {
        this.$message.warning('请先按时间或设备IMEI筛选后再导出，避免一次导出数百万条数据');
        return;
      }

      let filterInfo = [];
      if (this.searchParams.deviceImei) {
        filterInfo.push(`设备IMEI: ${this.searchParams.deviceImei}`);
      }
      if (this.searchParams.reportDateRange && this.searchParams.reportDateRange.length === 2) {
        filterInfo.push(`时间范围: ${this.searchParams.reportDateRange[0]} 至 ${this.searchParams.reportDateRange[1]}`);
      }

      const confirmMessage = `将导出以下条件筛选的数据：<br>${filterInfo.join('<br>')}<br><br>共 ${this.total} 条记录，数据量较大时可能需要一些时间，请耐心等待。`;

      try {
        await this.$confirm(confirmMessage, '确认导出', {
          type: 'warning',
          confirmButtonText: '确认导出',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true
        });
      } catch {
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: '正在导出CSV，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      try {
        let startTime = null;
        let endTime = null;
        if (this.searchParams.reportDateRange && this.searchParams.reportDateRange.length === 2) {
          startTime = this.searchParams.reportDateRange[0];
          endTime = this.searchParams.reportDateRange[1];
        }

        const allData = [];
        const pageSize = 1000;
        let currentPage = 1;
        let hasMore = true;

        while (hasMore) {
          loading.text = `正在获取数据... 已获取 ${allData.length} 条`;

          const params = {
            pageNum: currentPage,
            pageSize,
            deviceImei: this.searchParams.deviceImei,
            startTime,
            endTime,
          };

          for (const key in params) {
            if (params[key] === null || params[key] === undefined || params[key] === '') {
              delete params[key];
            }
          }

          const res = await this.$request.get('/deviceMonitorLogs/selectPage', { params });
          if (res.code !== '200') {
            this.$message.error('获取数据失败: ' + res.msg);
            loading.close();
            return;
          }

          const list = res.data?.list || [];
          allData.push(...list);
          const total = res.data?.total || 0;
          hasMore = allData.length < total;
          currentPage++;
        }

        if (allData.length === 0) {
          this.$message.warning('没有数据可以导出');
          loading.close();
          return;
        }

        loading.text = `正在生成CSV文件... 共 ${allData.length} 条数据`;

        const headers = [
          '序号', '设备IMEI', 'SOC (%)', '温度 (℃)', '电压 (mV)', '电流 (mA)', '剩余容量 (mAh)',
          'FCC满充容量 (mAh)', '循环次数快照', '纬度', '经度', '上报时间'
        ];

        const exportData = allData.map(item => ([
          item.id,
          item.deviceImei,
          item.soc !== null ? item.soc : '暂无数据',
          item.temperature || '',
          item.voltage || '',
          item.current || '',
          item.actualCapacityMah || '',
          item.fccMah || '暂无数据',
          item.cycleCountSnapshot !== null && item.cycleCountSnapshot !== undefined ? item.cycleCountSnapshot : '',
          item.latitude || '',
          item.longitude || '',
          this.formatDateTime(item.reportedAt)
        ]));

        const csvEscape = (value) => {
          if (value === null || value === undefined) return '';
          return `"${String(value).replace(/"/g, '""')}"`;
        };

        const csvRows = [
          headers.map(csvEscape).join(','),
          ...exportData.map(row => row.map(csvEscape).join(','))
        ];

        const now = new Date();
        const dateStr = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}_${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now.getSeconds().toString().padStart(2, '0')}`;

        let fileNameSuffix = '';
        if (this.searchParams.deviceImei) {
          fileNameSuffix += `_${this.searchParams.deviceImei}`;
        }
        if (this.searchParams.reportDateRange && this.searchParams.reportDateRange.length === 2) {
          const startDate = this.searchParams.reportDateRange[0].substring(0, 10).replace(/-/g, '');
          const endDate = this.searchParams.reportDateRange[1].substring(0, 10).replace(/-/g, '');
          fileNameSuffix += `_${startDate}至${endDate}`;
        }

        const fileName = `设备监控日志_${dateStr}${fileNameSuffix}.csv`;
        const csvContent = '\ufeff' + csvRows.join('\r\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        loading.close();
        this.$message.success(`导出成功，共导出 ${allData.length} 条数据`);
      } catch (error) {
        loading.close();
        console.error('导出失败:', error);
        this.$message.error('导出失败: ' + (error.message || '未知错误'));
      }
    },
  }
}
</script>

<style scoped>
/* 样式可以从 Admin.vue 或 Device.vue 复制或根据需要自定义 */
.search {
  margin-bottom: 10px;
}
.operation {
  margin-bottom: 10px;
}
.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style> 
